import pick from "lodash.pick";
import {getAction, httpAction} from "@api/manage";
import Clipboard from "clipboard";
export const CarFormMixins = {
  props: {
    //流程表单data
    formData: {
      type: Object,
      default: ()=>{},
      required: false
    },
    //表单模式：true流程表单 false普通表单
    formBpm: {
      type: Boolean,
      default: false,
      required: false
    },
    //表单禁用
    disabled: {
      type: Boolean,
      default: false,
      required: false
    },subHeight:{
      type: Number,
      default: 272,
      required: false
    }
  },
  data () {
    return {
      form: this.$form.createForm(this),
      model: {},
      height:document.documentElement.clientHeight,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      confirmLoading: false,
      validatorRules: {
        licensePlateNumber: {
          rules: [
            { required: true, message: '请输入车牌号!'},
            {validator:this.checkLicensePlateNumber}
          ]
        }
      },
      url: {
        add: "/dm/dmCar/add",
        edit: "/dm/dmCar/edit",
        queryById: "/dm/dmCar/queryById"
      },
      brandList:[],//品牌列表
      modelList:[],//车系列表
      brandModelMap:{},
      carId:"",
      uploadNum:0,
      position:localStorage.getItem("fz_position") || 'left',
      hoverStr:'',
      previewVisible:false,
      previewImage:"",
      viewerOptions:{
        title: false, // 显示当前图片的标题(显示alt属性或从URL解析出的图片名称)[布尔值/数字/方法/数组：默认true]
        toolbar: true, // 显示工具栏、自定义工具栏[布尔值/数字/对象：默认true]
        movable: true, // 图片是否可移动[布尔值：默认true]
        zoomable: true, // 图片是否可缩放[布尔值：默认true]
        url: 'src' // 播放时图片地址 URL 来源。[字符串/方法：默认src](如果是字符串，则应该是每个图像元素的属性之一。 如果是方法，则应该返回一个有效的图像URL)
      },
      otherImg:[
        {

        }
      ],
      fileUrl:''
    }
  },
  computed: {
    formDisabled(){
      if(this.formBpm===true){
        if(this.formData.disabled===false){
          return false
        }
        return true
      }
      return this.disabled
    },
    showFlowSubmitButton(){
      if(this.formBpm===true){
        if(this.formData.disabled===false){
          return true
        }
      }
      return false
    }
  },
  created () {
    //如果是流程中表单，则需要加载流程表单data
    //this.showFlowData();
    this.getBrandList();

  },
  methods: {
    add () {
      this.height += 60
      this.edit({"provincialAbbreviation":"沪"});
    },
    edit () {
      this.toTop();
      let record = this.formData;
      if(record){
        this.carId = record.id;
        if(record.carLicense){
          record.licenseImg =   record.carLicense.licenseImg;
          record.transportLicenseNo =   record.carLicense.transportLicenseNo;
          record.effectTime =   record.carLicense.effectTime;
          record.invalidTime =   record.carLicense.invalidTime;
          record.licenseFlag = record.carLicense.licenseFlag;
        }
        if(!(record.enclosureList&&record.enclosureList.length)){
          record.enclosureList = []
          record.enclosureList.push({
            imgPath:'',
            remark:""
          });
        }
        this.otherImg = record.fileList;
      }else{
        this.otherImg = [
          {
          }
        ]
      }

      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.visible = true;
      if(this.model.brandId){
        this.checkBrand(this.model.brandId,true);
      }

      this.$nextTick(() => {
        this.form.setFieldsValue(pick(this.model,'provincialAbbreviation','licensePlateNumber','brandId','modelId','owner','address','useNature','registrationTime','engineNumber'
          ,'carColor','plateColor','drivingLicenseMaster','drivingLicenseSlave','carHeadImg','carFooterImg','carFrameNoImg','vin','vinfzTime','vinCheckTime','modelNo','fzTime',
          'transportLicenseNo','effectTime','licenseFlag','invalidTime','carLicenseImg','carLabel'))
      })
      this.toTop();
    },toTop(){
      this.$nextTick(() => {
        let scrollElem = this.$refs.scrollDiv;
        if(scrollElem)
          scrollElem.scrollTo({ top: 0, behavior: 'smooth' });

        let scrollRight = this.$refs.scrollRight;
        if(scrollRight)
          scrollRight.scrollTo({ top: 0, behavior: 'smooth' });
      });
    },
    //渲染流程表单数据
    showFlowData(){
      if(this.formBpm === true){
        let params = {id:this.formData.dataId};
        getAction(this.url.queryById,params).then((res)=>{
          if(res.success){
            this.edit (res.result);
          }
        });
      }
    },
    submitForm (activeKey) {
      const that = this;
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          if(activeKey){
            that.$emit('switchActive',activeKey);
            return;
          }
          if(values.useNature && isNaN(values.useNature)){
            that.$refs.alert.errorMsg("行驶证使用性质填写错误【"+values.useNature+"】，请手动纠正!")
          }

          let formData = Object.assign(this.model, values);
          //formData.licensePlateNumber = formData.provincialAbbreviation + formData.licensePlateNumber;
          console.log("表单提交数据",formData)
          formData.carLicense = {
            licenseImg:formData.licenseImg,
            transportLicenseNo:formData.transportLicenseNo,
            effectTime:formData.effectTime,
            invalidTime:formData.invalidTime,
            licenseFlag:formData.licenseFlag
          }
          if(this.model.carLicense){
            formData.carLicense.id=this.model.carLicense.id
          }
          if(this.model.enclosureList && this.model.enclosureList.length){
            formData.enclosureList = this.model.enclosureList
            if(this.model.id){
              for(let a in formData.enclosureList){
                formData.enclosureList[a].carId = this.model.id
              }
            }

          }
          formData.fileList = this.otherImg;
          that.$emit('getData',formData);
        }else{
          that.$refs.alert.errorMsg("请先输入车牌号!",2000);
        }

      })
    },close(){
      this.closeCurrent();
    },closeTab(){
      this.$emit("close")
    },
    popupCallback(row){
      this.form.setFieldsValue(pick(row,'provincialAbbreviation','licensePlateNumber','brandId','modelId','owner','address','useNature','registrationTime','engineNumber','carColor','plateColor','drivingLicenseMaster','drivingLicenseSlave','carHeadImg','carFooterImg','carFrameNoImg','vin','vinfzTime','vinCheckTime','modelNo','fzTime',
        'transportLicenseNo','effectTime','licenseFlag','invalidTime','licenseImg','carLabel'))
    },getBrandList(){

      var that =this;

      getAction("/dm/dmCarBrand/queryAllList",{}).then((res)=>{
        if(res.success){
          let brandList = res.result;
          if(brandList){
            for(var k in brandList){
              that.brandList.push({
                text:brandList[k].brandName,
                value:brandList[k].id
              });
              this.brandModelMap[brandList[k].id] = brandList[k].brandName
            }

          }
        }
      });
    },checkBrand(brandId,isEdit){
      this.modelList = [];
      if(brandId){
        //if(this.brandModelMap[brandId]){
        //this.modelList = this.brandModelMap[brandId];
        //that.$refs.modelSelect.setCurrentDictOptions(that.modelList);
        //}else{
        this.getModelList(brandId);
        //}

      }else{
        this.$refs.modelSelect.setCurrentDictOptions(this.modelList);
      }
      if(!isEdit){
        this.model.modelId = null;
        this.model.brandId = brandId;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'modelId'))
        })
      }
      if(!this.disabled){
        this.$emit("hasChange",true);
      }

    },
    getModelList(brandId){
      var that =this;
      getAction("/dm/dmCarBrandModel/listByBrandId",{"brandId":brandId}).then((res)=>{
        if(res.success){
          let modelList = res.result;
          if(modelList){
            for(var k in modelList){
              that.modelList.push({
                text:modelList[k].modelName,
                value:modelList[k].id
              });
              this.brandModelMap[modelList[k].id] = modelList[k].modelName
            }

          }else{
            that.modelList = [];
            //that.$refs.modelSelect.setCurrentDictOptions(that.modelList);
          }
          // if(!this.brandModelMap[brandId]){
          //   this.brandModelMap[brandId] = that.modelList;
          // }
        }
      });
    },getOcrInfo(ocrInfo){
      console.log(ocrInfo)
      if(ocrInfo){
        if(ocrInfo.licenseNumber && !this.model.id){
          this.model.licensePlateNumber = ocrInfo.licenseNumber;
        }

        if( ocrInfo.brandId){
          this.model.brandId = ocrInfo.brandId
          this.checkBrand(ocrInfo.brandId);
        }
        if( ocrInfo.modelId){
          this.model.modelId = ocrInfo.modelId
        }
        if( ocrInfo.onwer){
          this.model.owner = ocrInfo.onwer
        }
        if( ocrInfo.address){
          this.model.address = ocrInfo.address
        }
        if(ocrInfo.nature && !isNaN(ocrInfo.nature)){
          this.model.useNature = ocrInfo.nature
        }
        if(ocrInfo.regDate){
          this.model.registrationTime = ocrInfo.regDate
        }
        if(ocrInfo.fzDate){
          this.model.fzTime = ocrInfo.fzDate
        }
        if(ocrInfo.fdjNo){
          this.model.engineNumber = ocrInfo.fdjNo
        }
        if(ocrInfo.carModel){
          this.model.modelNo = ocrInfo.carModel
        }
        if(ocrInfo.vehicleLicenseNo){
          this.model.vin = ocrInfo.vehicleLicenseNo
        }
      }
      this.$nextTick(() => {
        this.form.setFieldsValue(pick(this.model,'licensePlateNumber','brandId','modelId','owner','address','useNature','registrationTime'
          ,'engineNumber','modelNo','vin','fzTime'
        ))
        this.form.validateFields();
      })
      //this.form.validateFields();
    },getImgState(num){
      this.uploadNum += num;
      console.log("这个时候状态值为：",this.uploadNum)
    },checkLicensePlateNumber(rule, value, callback){
      let that = this;
      const form = this.form;
      let licensePlateNumber = form.getFieldValue("licensePlateNumber");

      if(!licensePlateNumber){
        callback();
      }else{
        // 省份简称(含使/领用于使领馆号牌)
        const province = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-HJ-NP-Z][A-HJ-NP-Z0-9]{4,5}[A-HJ-NP-Z0-9挂学警港澳]$/;

        if(province.test(licensePlateNumber)){
          let formData = {
            "licensePlateNumber":licensePlateNumber,
            id:this.carId
          }

          getAction("/dm/dmCar/licensePlateNumber",formData).then((res)=>{
            if(res.success){
              that.$refs.repeat.edit(res.result,this.formData.driverId);
              callback("车牌号被占用!");
            }else{
              callback();
            }
          })
        }else{
          callback("车牌号有误，请纠正!");
        }

      }

    }, checkChange(colum){
      this.$nextTick(()=>{
        let val =  this.form.getFieldsValue();
        this.model[colum] = val[colum];
      });

      console.log("checkChange",this.model);
      this.$emit("hasChange",true);
    },bdCarDriver(carId){
      let formData = {"carId":carId,
        driverId:this.driverId

      }
      let that = this;
      httpAction("/dm/dmDriver/bdCar",formData,'post').then((res)=>{
        if(res.success){
          that.$message.success(res.message);
          that.$emit("closeOk");
        }else{
          that.$message.warning(res.message);
        }
      }).finally(() => {
        that.confirmLoading = false;
      })
    },checkPosition(){

      this.form.validateFields((err, values) => {
        if(this.position=='left'){
          this.position='right'
        }else{
          this.position='left'
        }
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'provincialAbbreviation','licensePlateNumber','brandId','modelId','owner','address','useNature','registrationTime','engineNumber'
            ,'carColor','plateColor','drivingLicenseMaster','drivingLicenseSlave','carHeadImg','carFooterImg','carFrameNoImg','vin','vinfzTime','vinCheckTime','modelNo','fzTime',
            'transportLicenseNo','effectTime','invalidTime','licenseImg'))
        })
        localStorage.setItem("fz_position",this.position)
      })


    },copyText(id){

      let _this = this
      let clipborad = new Clipboard('#'+id);
      //复制成功
      clipborad.on('success', function() {
        _this.$message.success('复制成功！')
        clipborad.destroy();
      })
    },hoverA(a,b){

      this.hoverStr = a+""+b;
      console.log(this.hoverStr)
    },unHoverA(id){
      if(!this.checkIn(document.getElementById(id))){
        this.hoverStr = ""
      }
    },
    // 判断鼠标是否落在一个块级元素内部
    checkIn(obj) {
      if(!obj){
        return;
      }
      var x = Number(window.event.clientX) // 鼠标相对屏幕横坐标
      var y = Number(window.event.clientY) // 鼠标相对屏幕纵坐标

      var div_x = Number(obj.getBoundingClientRect().left) // obj相对屏幕的横坐标
      var div_x_width = Number(
        obj.getBoundingClientRect().left + obj.clientWidth
      ) // obj相对屏幕的横坐标+width

      var div_y = Number(obj.getBoundingClientRect().top) // obj相对屏幕的纵坐标
      var div_y_height = Number(
        obj.getBoundingClientRect().top + obj.clientHeight
      ) // obj相对屏幕的纵坐标+height

      if (x > div_x && x < div_x_width && y > div_y && y < div_y_height) {
        return true
      } else {
        return false
      }
    },
    addEnclosure(){
      this.model.enclosureList.push({
        imgPath:'',
        remark:""
      })
    },removeEnclosure(idx){
      this.model.enclosureList.splice(idx,1);
    },getInfo(carId){
      this.$emit("getInfo",carId)
    },hoverSpace(top){
      ///this.scrollToElement(top);
    }, scrollToElement(top) {
      const el =    this.$refs.scrollRight;
      console.log(el)
      if (el) {
        el.scrollTo(0,top)
      }
    },
    handleCancel() {
      this.previewVisible = false;
    },viewOtherImage(imageUrl){
      this.previewImage = imageUrl
      this.$refs.viewer.$viewer.show();
    },changeOtherImg( idx){
      let img = this.otherImg[idx];
      if(this.fileUrl){
        img.fileUrl = this.fileUrl;
        this.otherImg.unshift({
          fileUrl:''
        })
      }else{
        //this.otherImg.splice(idx,1);
      }

    },handleDragStart(e, imgUrl){
      if(this.disabled){
        return;
      }
      // 存储图片URL到拖拽数据中
      e.dataTransfer.setData('text/plain', imgUrl);
      // 设置拖拽效果
      e.dataTransfer.effectAllowed = 'copy';
    },setValue( val,colum){
      console.log("setValue",val,colum)
      this.model[colum] = val;
      this.$nextTick(() => {
        this.form.setFieldsValue(pick(this.model,colum))
      });
      val = decodeURIComponent( val);

      for(let a in this.otherImg){
        if(val.indexOf(this.otherImg[a].fileUrl)!=-1){
          this.otherImg.splice(a,1);
          break;
        }

      }
    },deleteImg(idx){
      this.otherImg.splice(idx,1);
    },tranferToRight(column){
      let img = this.model[ column];
      console.log(img)
      this.otherImg.push({
        fileUrl:img
      })
      this.model[ column] = '';
      this.form.setFieldsValue(pick(this.model,column))
    }
  }
}